export default "__VITE_ASSET__01df42f9__"